'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dColumn from "./presto.-Column.js";
import * as $j_presto$002e$002dGroup$002dUsers$002dView$0024$0024anon$002410 from "./presto.-Group-Users-View$$anon$10.js";
import * as $j_presto$002e$002dGroup$002dUsers$002dView$0024$0024anon$002411 from "./presto.-Group-Users-View$$anon$11.js";
import * as $j_presto$002e$002dTable$0024 from "./presto.-Table$.js";
import * as $j_presto$002etable$0024package$0024 from "./presto.table$package$.js";
import * as $j_presto$002etable$0024package$0024$0024anon$00244 from "./presto.table$package$$anon$4.js";
import * as $j_presto$002etable$0024package$0024$0024anon$00246 from "./presto.table$package$$anon$6.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupUsersView() {
  this.aXh = null;
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$();
  var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$();
  var render$2 = new $j_presto$002e$002dGroup$002dUsers$002dView$0024$0024anon$002410.$c_Lpresto_GroupUsersView$$anon$10(this);
  var sorting$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some(new $j_presto$002e$002dGroup$002dUsers$002dView$0024$0024anon$002411.$c_Lpresto_GroupUsersView$$anon$11(this));
  this.aXh = $x_2.ag($x_1.c(new ($j_presto$002e$002dColumn.$d_Lpresto_Column.r().C)([new $j_presto$002e$002dColumn.$c_Lpresto_Column("EMAIL", "Email", render$2, new $j_presto$002etable$0024package$0024$0024anon$00246.$c_Lpresto_table$package$$anon$6($j_presto$002etable$0024package$0024.$m_Lpresto_table$package$()), sorting$2, false)])));
}
export { $c_Lpresto_GroupUsersView as $c_Lpresto_GroupUsersView };
$p = $c_Lpresto_GroupUsersView.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupUsersView;
/** @constructor */
function $h_Lpresto_GroupUsersView() {
}
export { $h_Lpresto_GroupUsersView as $h_Lpresto_GroupUsersView };
$h_Lpresto_GroupUsersView.prototype = $p;
$p.cPA = (function(data, selectable, selected) {
  return $j_presto$002e$002dTable$0024.$m_Lpresto_Table$().eb(this.aXh, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$18) => _$18.ix)), data, selectable, selected, new $j_presto$002etable$0024package$0024$0024anon$00244.$c_Lpresto_table$package$$anon$4($j_presto$002etable$0024package$0024.$m_Lpresto_table$package$()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
var $d_Lpresto_GroupUsersView = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupUsersView, "presto.GroupUsersView", ({
  JN: 1
}));
export { $d_Lpresto_GroupUsersView as $d_Lpresto_GroupUsersView };
//# sourceMappingURL=presto.-Group-Users-View.js.map
